// @flow strict
import * as React from 'react'

import { type PropsWithChildren } from '@mondough/public-web-components'
import styles from './DisclosureGroup.module.scss'
import {
  SectionWrapper,
  SectionThemes,
  getSectionTheme,
} from './SectionWrapper'
import SubtitleSection from './SubtitleSection'
import DisclosureItem, { type DisclosureItemProps } from './DisclosureItem'

export type DisclosureGroupProps = {|
  items: Array<DisclosureItemProps>,
  flags: { [k: string]: string | number },
|}

export default function DisclosureGroup(
  props: PropsWithChildren<
    DisclosureGroupProps,
    React.Element<typeof SubtitleSection>,
  >,
) {
  const { items, children, flags } = props

  let sectionTheme = getSectionTheme(flags, SectionThemes.LIGHT)

  return (
    <SectionWrapper
      theme={sectionTheme}
      contentClassName={styles.baseContent}
      className={styles.section}
    >
      {children}
      {items.map(item => (
        <DisclosureItem title={item.title} content={item.content} />
      ))}
    </SectionWrapper>
  )
}
